import React, { useEffect } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '..';


const WorkForceList = ({ data }) => {
    const navigate = useNavigate();

    const handleDelete = async (id) => {
        try {
            const response = await fetch(`${API_URL}/api/workforce/single/${id}`, {
                method: 'DELETE'
            });
            if (response.status === 200) {
                window.location.reload();
            } else {
                const data = await response.json();
                alert(`Failed to delete workforce member: ${data.message}`);
            }
        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    };

    const handleStatusChange = async (id, status) => {
        try {
            const response = await fetch(`${API_URL}/api/workforce/update-status/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ status })
            });
            if (response.status === 200) {
                window.location.reload();
            } else {
                const data = await response.json();
                alert(`Failed to update status: ${data.message}`);
            }
        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
            navigate('/login');
            return;
        }

        const table = $('#workforceTable').DataTable({
            data: data,
            order: [[0, 'desc']],
            responsive: true,
            pageLength: 10,
            columns: [
                { data: 'id' },
                {
                    data: 'userImage',
                    render: function (data, type, row) {
                        return data ? `<img src="${API_URL}${data}" alt="Workforce" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;" />` : '<span>No Image</span>';
                    }
                },
                { data: 'fullName' },
                { data: 'phoneNumber' },
                {
                    data: 'status',
                    render: function (data, type, row) {
                        return `
                            <select class="status-select" data-id="${row.id}">
                                <option value="active" ${data === 'active' ? 'selected' : ''}>Active</option>
                                <option value="inactive" ${data === 'inactive' ? 'selected' : ''}>Inactive</option>
                            </select>
                        `;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        return `
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="ph ph-list"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><Icon icon="material-symbols:visibility" className="me-1" /> View</a></li>
                                    <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><Icon icon="material-symbols:edit" className="me-1" /> Edit</a></li>
                                    <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><Icon icon="material-symbols:delete" className="me-1" /> Delete</a></li>
                                </ul>
                            </div>
                        `;
                    },
                    title: 'Actions',
                    orderable: false
                }
            ]
        });

        // Event listener for status change
        $('#workforceTable tbody').on('change', '.status-select', function () {
            const id = $(this).data('id');
            const status = $(this).val();
            handleStatusChange(id, status);
        });

        // Event listeners for action buttons
        $('#workforceTable tbody').on('click', '.view-btn', function () {
            const id = $(this).data('id');
            navigate(`/view-workforce/${id}`);
        });

        $('#workforceTable tbody').on('click', '.edit-btn', function () {
            const id = $(this).data('id');
            navigate(`/edit-workforce/${id}`);
        });

        $('#workforceTable tbody').on('click', '.delete-btn', function () {
            const id = $(this).data('id');
            if (window.confirm('Are you sure you want to delete this workforce member?')) {
                handleDelete(id);
            }
        });

        return () => {
            table.destroy(true);
        };
    }, [data, navigate]);

    return (
        <div className="card basic-data-table">
            <div className="card-header">
                <h5 className="card-title mb-0">List of Workforce</h5>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0"
                    id="workforceTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">
                                <div className="form-check style-check d-flex align-items-center">
                                    <label className="form-check-label">S.L</label>
                                </div>
                            </th>
                            <th scope="col">Image</th>
                            <th scope="col">Full Name</th>
                            <th scope="col">Phone Number</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        </div>
    );
};

export default WorkForceList;